










































































import { Component, Mixins, Prop } from 'vue-property-decorator'

import ClipboardCopyMixin from '../logic/helpers/ClipboardCopyMixin'
import { atSignedLogin, loginWithoutAtSign } from "../shared/utils/tgLoginHelpers";
import Icon from './Icon/Icon.vue'

type UserDataKeys = 'id' | 'login' | 'name'

@Component({
  components: {
    Icon
  },
  methods: {
    loginWithoutAtSign,
    atSignedLogin
  }
})
export default class UserMainInfo extends Mixins<ClipboardCopyMixin>(ClipboardCopyMixin) {
  @Prop() avatar!:string

  @Prop() name!:string | null

  @Prop() login!:string | null

  @Prop() id!:number | string

  @Prop({ type: Boolean, required: false, default: false }) isAdmin!:boolean

  @Prop() direction!: 'column' | 'inline' | 'inline-reverse'

  @Prop({ type: Boolean, required: false, default: false }) responsive!:boolean

  @Prop( { type: Boolean, required: false, default: false }) banned!: boolean | undefined

  @Prop({ type: Number, required: false, default: 25 }) nameLimit!:number

  @Prop( { type: Array, default: () => [] }) copyTo!:Array<UserDataKeys>

  // to be careful of @@login in template
  get clearlyLoginString() {
    return atSignedLogin(loginWithoutAtSign(this.login || ''))
  }

  get userInfoStyles():string {
    if (this.direction === 'column') {
      return 'flex flex-col items-center justify-center'
    } else if (this.direction === 'inline-reverse') {
      return 'flex flex-row-reverse items-center'
    } else {
      return 'flex items-center'
    }
  }

  get userDataStyles():string {
    const responsiveStyles = this.responsive ? 'hidden xs:flex' : ""

    if (this.direction === 'column') {
      return 'flex flex-col items-center mt-1 ' + responsiveStyles
    } else if (this.direction === 'inline-reverse') {
      return 'flex flex-col text-right mr-1 ' + responsiveStyles
    } else {
      return 'flex flex-col text-left ml-1 ' + responsiveStyles
    }
  }

  cutIfLarge(str:string) {
    if (str.length > this.nameLimit) {
      return str.slice(0, this.nameLimit + 1) + "..."
    }

    return str
  }

  hasKeyInCopyToList(userDataKey: UserDataKeys) {
    if (this.copyTo && this.copyTo.length) {
      return this.copyTo.indexOf(userDataKey) !== -1
    }

    return false
  }

  hoverableStylesIfToCopy(userDataKey: UserDataKeys) {
    if (this.hasKeyInCopyToList(userDataKey)) {
      return 'cursor-pointer hover:opacity-75 underline select-none'
    }

    return ''
  }

  handleClick(userDataKey: UserDataKeys, value: string | number) {
    if (this.hasKeyInCopyToList(userDataKey)) {
      let dataToCopy = typeof value === 'number' ? value.toString() : value

      this.copy(dataToCopy)
    }
  }
}
